import { createAppKit } from '@reown/appkit/vue'
import { mainnet, bsc, bscTestnet } from '@reown/appkit/networks'
import { EthersAdapter } from '@reown/appkit-adapter-ethers'
import type { App, Plugin } from 'vue'

// 项目配置
const projectId = '3740dd25ed69cde31c2f91fdfa7a8bfd'
const walletConnectRpc = (chainId: number) => `https://rpc.walletconnect.org/v1/?chainId=eip155:${chainId}&projectId=${projectId}`
const customBsc = {
  ...bsc,
  id: 56,
  name: 'BSC',
  rpcUrls: {
    default: {
      http: [
        walletConnectRpc(56),
        'https://bsc-dataseed.binance.org/',
        'https://bsc-dataseed1.defibit.io/',
        'https://bsc-dataseed2.defibit.io/',
        'https://bsc-dataseed3.defibit.io/',
        'https://bsc-dataseed4.defibit.io/',
        'https://bsc-dataseed1.ninicoin.io/',
        'https://bsc-dataseed2.ninicoin.io/',
        'https://bsc-dataseed3.ninicoin.io/',
        'https://bsc-dataseed4.ninicoin.io/',
        'https://bsc.publicnode.com',
        'https://bsc.1rpc.io'
      ],
    },
  },
}

// // 自定义网络配置
// const customMainnet = {
//   ...mainnet,
//   id: 1,
//   name: 'Ethereum',
// }

// const customBsc = {
//   ...bsc,
//   id: 56,
//   name: 'BSC',
// }

// 应用元数据
const metadata = {
  name: 'GLB',
  description: 'Golden Luck Bthena',
  url: 'http://glb.meme:5173', // origin must match your domain & subdomain
  icons: ['https://avatars.githubusercontent.com/u/179229932']
}

// 创建 Ethers 适配器
const ethersAdapter = new EthersAdapter()

// 创建 AppKit 实例
export const appkit = createAppKit({
  adapters: [ethersAdapter],
  networks: [ customBsc],
  defaultNetwork: customBsc,
  projectId,
  metadata,
  themeMode: 'dark',
  themeVariables: {
    '--w3m-color-mix': '#A21AF7FF',
    '--w3m-color-mix-strength': 10,
  },
  features: {
    analytics: false,
    email: false,
    socials: false,
    swaps: false,
    onramp: false,
  },
})

// 创建 Vue 插件
export const appkitPlugin: Plugin = {
  install(app: App) {
    app.provide('appkit', appkit)
  },
}
